import React from 'react';
import { IonButton, IonIcon } from '@ionic/react';
import { connect } from 'react-redux';
import { resetAppointment } from '../store/actions/appointments';
import { logOutOutline } from 'ionicons/icons';
import { AuthenticationRootState } from '../store/reducers/authentication';
import EventBus from '../services/EventBus';
import { logout } from '../store/actions/authentication';
import { useLogoutCallback } from '../hooks/msal.hooks';

const mapDispatchToProps = (dispatch: Function, ownProps: any) => ({
  resetAppointment: () => dispatch(resetAppointment()),
  logout: () => dispatch(logout())
});

const mapStateToProps = (
  state: {
    authentication: AuthenticationRootState;
  },
  ownProps: any
) => {
  return {
    isRopc: state.authentication.isRopc
  };
};
const LogoutBtn: React.FC<
  ReturnType<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>
> = ({ resetAppointment, isRopc, logout }) => {
  const handleLogout = useLogoutCallback();
  function onClickLogout() {
    EventBus.success('À bientôt chez Unilabs !');
    resetAppointment();
    if (isRopc) {
      logout();
    } else {
      handleLogout();
    }
  }

  return (
    <IonButton fill="clear" onClick={() => onClickLogout()}>
      <IonIcon icon={logOutOutline} slot="start"></IonIcon>
      Déconnexion
    </IonButton>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(LogoutBtn);
